export default __webpack_public_path__ + "static/media/icon_star_smile_btn.b763e510.svg";